import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import {
	AfterViewInit,
	Directive,
	ElementRef,
	Input,
	OnDestroy,
	Renderer2,
	TemplateRef,
	ViewContainerRef,
} from '@angular/core';
import { Unsubscribable } from '@ats/utility';
import { merge } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { CmContextOverlayComponent } from '../components/cm-context-overlay/context-overlay.component';

@Directive({
    selector: '[cmOverlayTriggerFor]',
    standalone: false
})
export class CmContextOverlayDirective extends Unsubscribable implements AfterViewInit, OnDestroy {
	// ts-lint:ignore-next-line
	@Input('cmOverlayTriggerFor') component: CmContextOverlayComponent;
	@Input() cmOverlayTemplate: TemplateRef<any>;
	@Input() cmOverlayContext: any;
	@Input() cmOverlayTitleTemplate: TemplateRef<any>;
	@Input() cmOverlayTitleContext: any;
	private overlayRef: OverlayRef;
	private portal: TemplatePortal<any>;

	constructor(
		private el: ElementRef,
		private overlay: Overlay,
		private viewRef: ViewContainerRef,
		private renderer: Renderer2
	) {
		super();
	}

	ngAfterViewInit() {
		this.renderer.listen(this.el.nativeElement, 'click', () => this.toggleOverlay());
	}

	private toggleOverlay() {
		if (!this.overlayRef) this.createOverlay();

		if (this.overlayRef.hasAttached()) {
			this.overlayRef.detach();
		} else {
			if (this.cmOverlayContext) this.component.context = this.cmOverlayContext;
			if (this.cmOverlayTemplate) this.component.contentTpl = this.cmOverlayTemplate;
			if (this.cmOverlayTitleContext) this.component.titleContext = this.cmOverlayTitleContext;
			if (this.cmOverlayTitleTemplate) this.component.titleTpl = this.cmOverlayTitleTemplate;
			this.portal = new TemplatePortal(this.component.template, this.viewRef);
			this.overlayRef.attach(this.portal);

			merge(this.component.close$, this.overlayRef.backdropClick())
				.pipe(take(1))
				.subscribe(() => this.overlayRef.detach());
		}
	}

	private createOverlay() {
		this.overlayRef = this.overlay.create({
			backdropClass: 'bg-transparent',
			hasBackdrop: true,
			positionStrategy: this.overlay
				.position()
				.flexibleConnectedTo(this.el)
				.withFlexibleDimensions(false)
				.withPositions([
					{
						originX: 'start',
						originY: 'bottom',
						overlayX: 'start',
						overlayY: 'top',
					},
					{
						originX: 'start',
						originY: 'top',
						overlayX: 'start',
						overlayY: 'bottom',
					},
						{
							originX: 'start',
							originY: 'top',
							overlayX: 'end',
							overlayY: 'center',
						},
				]),
				scrollStrategy: this.overlay.scrollStrategies.block(),
		});
	}
}
